export const RenderDynamicIconState = {
  Pending: 'pending',
  Success: 'success',
  Error: 'error',
} as const

export type RenderDynamicIconState =
  (typeof RenderDynamicIconState)[keyof typeof RenderDynamicIconState]
